import { render, staticRenderFns } from "./YoutubeRemovalClaims.vue?vue&type=template&id=234cd8fe"
import script from "./YoutubeRemovalClaims.vue?vue&type=script&lang=js"
export * from "./YoutubeRemovalClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports